import { reducer } from './test-monkey.reducer';

export const reducers = reducer;
